import { render } from "./AgendaDateTime.vue?vue&type=template&id=765acf30"
import script from "./AgendaDateTime.vue?vue&type=script&lang=js"
export * from "./AgendaDateTime.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__